import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function DeleteWord(props) {
  const detectSize600px = useMediaQuery("(min-width:600px)");

  const { handleCloseDialogContent, dataContent, deleteWordFromFromBack } =
    props;
  let wordId = dataContent;
  const handleDeleteWord = async () => {
    await deleteWordFromFromBack({ wordId });
    handleCloseDialogContent();
  };

  return (
    <>
      <DialogContent dividers>
        <Box>آیا از حذف این لغت مطمین هستید</Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseDialogContent}
          color="primary"
          variant="outlined"
          autoFocus
        >
          لغو
        </Button>
        <Button onClick={handleDeleteWord} variant="outlined" color="error">
          بله
        </Button>
      </DialogActions>
    </>
  );
}
